/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  MigrateIssuerRequestBody2,
  MigrateIssuerRequestBody2$Outbound,
  MigrateIssuerRequestBody2$outboundSchema,
} from "../components/migrateissuerrequestbody2.js";

export type MigrateOrganizationUserSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type MigrateOrganizationUserSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  migrateIssuerRequestBody2: MigrateIssuerRequestBody2;
};

/** @internal */
export type MigrateOrganizationUserSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const MigrateOrganizationUserSessionIssuerSecurity$outboundSchema:
  z.ZodMiniType<
    MigrateOrganizationUserSessionIssuerSecurity$Outbound,
    MigrateOrganizationUserSessionIssuerSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function migrateOrganizationUserSessionIssuerSecurityToJSON(
  migrateOrganizationUserSessionIssuerSecurity:
    MigrateOrganizationUserSessionIssuerSecurity,
): string {
  return JSON.stringify(
    MigrateOrganizationUserSessionIssuerSecurity$outboundSchema.parse(
      migrateOrganizationUserSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type MigrateOrganizationUserSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  MigrateIssuerRequestBody2: MigrateIssuerRequestBody2$Outbound;
};

/** @internal */
export const MigrateOrganizationUserSessionIssuerRequest$outboundSchema:
  z.ZodMiniType<
    MigrateOrganizationUserSessionIssuerRequest$Outbound,
    MigrateOrganizationUserSessionIssuerRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      migrateIssuerRequestBody2: MigrateIssuerRequestBody2$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        migrateIssuerRequestBody2: "MigrateIssuerRequestBody2",
      });
    }),
  );

export function migrateOrganizationUserSessionIssuerRequestToJSON(
  migrateOrganizationUserSessionIssuerRequest:
    MigrateOrganizationUserSessionIssuerRequest,
): string {
  return JSON.stringify(
    MigrateOrganizationUserSessionIssuerRequest$outboundSchema.parse(
      migrateOrganizationUserSessionIssuerRequest,
    ),
  );
}
